/*
 * Essential imports
 */
import 'picturefill';
import 'lazysizes';

/*
 * Essential fixes
 */

// Preload and No-JS
setTimeout(() => {
    document.documentElement.classList.remove('preload');
    document.documentElement.classList.remove('no-js');
}, 300);

let resizeId;

window.addEventListener('resize', () => {
    clearTimeout(resizeId);
    document.documentElement.classList.add('preload');
    resizeId = setTimeout(() => {
        document.documentElement.classList.remove('preload');
    }, 300);
});

// Fix NodeList.forEach in IE11
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

/*
 * Function imports
 */
// import { INIT_forms } from './functions/forms';
// import { INIT_modals } from './functions/modals';

/*
 * Google maps
 */
import { initMap } from './map.js';
window.initMap = initMap;

/*
 * Animate on Scroll
 */
import AOS from 'aos';
AOS.init();

/*
 * Splide Carousel
 */
import Splide from '@splidejs/splide';

const sliders = [...document.querySelectorAll('.splide')];
if (sliders) {
    sliders.forEach(slider => {
        new Splide(slider).mount();
    });
}

if(document.getElementsByClassName( 'splide-blog' ).length > 0) {
    new Splide('.splide-blog', {
        focusAt: 'center',
        pagination: false,
        perView: 5,
        gap: 20,
    }).mount();
}

if(document.getElementsByClassName( 'splide-testimonials' ).length > 0) {
    new Splide('.splide-testimonials', {
        pagination: false,
        type: 'loop',
    }).mount();
}

if(document.getElementsByClassName( 'splide-block' ).length > 0) {
    new Splide('.splide-block', {
        pagination: false,
        autoplay: 3000,
        type: 'loop',
    }).mount();
}

/*
 * Burger menu
 */
const burgerButton = document.querySelector('.burger-button');
const burgerClose = document.querySelector('.burger-close');
const burgerBars = document.querySelector('.burger-bars');
const viewButton = document.querySelector('.view-button');
const navMenu = document.querySelectorAll('.burger-menu');
var burgerShow = false;
burgerButton.addEventListener('click', (e) => {
    if(!burgerShow) {
        e.stopPropagation();
        showBurgerMenu();
    } else {
        hideBurgerMenu();
    }
});
function showBurgerMenu() {
    burgerShow = true;
    burgerBars.classList.add('hidden');
    burgerClose.classList.remove('hidden');
    navMenu.forEach(function(element) {
        element.classList.add('open');
    });
}
// Close the menu when clicking elsewhere
document.addEventListener('click', (e) => {
    if(burgerShow) {
        e.stopPropagation();
        burgerShow = false;
        hideBurgerMenu();
    }
});
function hideBurgerMenu() {
    burgerShow = false;
    burgerBars.classList.remove('hidden');
    burgerClose.classList.add('hidden');
    navMenu.forEach(function(element) {
        element.classList.remove('open');
    });
}

/*
 * Sticky header
 */
const header = document.querySelector('.site-header');
const content = document.querySelector('.main');
const hoffset = header.offsetHeight + 33;
function updateHeaderSticky() {
    if(window.screen.width > 768) {
        var offset = hoffset + header.offsetTop;
        if (window.scrollY > offset) {
            header.classList.add('sticky');
            content.setAttribute('style', 'padding-top:' + offset + 'px');
        } else {
            header.classList.remove('sticky');
            content.setAttribute('style', 'padding-top:0px');
        }
    } else {
        header.classList.remove('sticky');
        content.setAttribute('style', 'padding-top:0px');
    }
    // Hide view button
    if(viewButton) {
        if (window.scrollY > 2000) {
            viewButton.classList.add('close');
        } else {
            viewButton.classList.remove('close');
        }
    }
}
window.addEventListener('scroll', updateHeaderSticky);

/*
    Smooth Scroll
    @param pos: the y-position to scroll to (in pixels)
    @param time: the exact amount of time the scrolling will take (in milliseconds)
*/
function scrollToSmoothly(pos, time) {
    var currentPos = window.pageYOffset;
    var start = null;
    if(time == null) time = 500;
    pos = +pos, time = +time;
    window.requestAnimationFrame(function step(currentTime) {
        start = !start ? currentTime : start;
        var progress = currentTime - start;
        if (currentPos < pos) {
            window.scrollTo(0, ((pos - currentPos) * progress / time) + currentPos);
        } else {
            window.scrollTo(0, currentPos - ((currentPos - pos) * progress / time));
        }
        if (progress < time) {
            window.requestAnimationFrame(step);
        } else {
            window.scrollTo(0, pos);
        }
    });
}

// Anchor Scrolling
// window.onload = function() {
    if ( window.location.hash ) {
        var target = window.location.hash.slice( 1 );
        var scroll = document.querySelector(`#${target}`).offsetTop - hoffset;
        scrollToSmoothly(scroll, 300);
    }
// };

/*
 * Location Note
 */
var locationNotes = document.querySelectorAll('.location-note');
if(locationNotes) locationNotes.forEach( function(element) {
    var locationInfo = element.querySelector('.location-info');
    if(locationInfo) element.addEventListener("mouseover", function() {
        locationInfo.classList.add('tooltip-open');
    });
});

/*
 * Unit Coupons (Offers) - Legacy code to handle coupon hover tooltip
 */
// var productCoupons = document.querySelectorAll('.product-coupon');
// if(productCoupons) productCoupons.forEach( function(element) {
//     var productInfo = element.querySelector('.product-info');
//     if(productInfo) {
//         element.addEventListener("mouseover", function() {
//             //console.log("Coupon hover");
//             productInfo.classList.add('app-tooltip-open');
//         });
//         element.addEventListener("mouseout", function() {
//             //console.log("Coupon hide tooltip");
//             productInfo.classList.remove('app-tooltip-open');
//         });
//         // element.addEventListener("click", function() {
//         //     //console.log("Coupon click");
//         //     productInfo.classList.toggle('app-tooltip-open');
//         // });
//     }
// });

/*
 * Unit Toggle - Metric / Imperial
 */
if(document.getElementById('unit-toggle')) {
    document.getElementById('unit-toggle').addEventListener('change', function(e) {
        if(e.target.checked) {
            document.querySelectorAll('.unit-imperial').forEach(function(element) {
                element.classList.remove('hidden');
            });
            document.querySelectorAll('.unit-metric').forEach(function(element) {
                element.classList.add('hidden');
            });
        } else {
            document.querySelectorAll('.unit-imperial').forEach(function(element) {
                element.classList.add('hidden');
            });
            document.querySelectorAll('.unit-metric').forEach(function(element) {
                element.classList.remove('hidden');
            });
        }
    });
}

/*
 * Unit Toggle - Unit Card Form - Show / Hide
 */
document.querySelectorAll('.product-unit').forEach(function(element) {
    var i = element.getAttribute('data-index');
    var form = document.getElementById('product-' + i + '-form');
    var button = element.querySelector('.product-form-button');
    var close = element.querySelector('.product-form-close');
    var pullup = form.querySelector('.product-form-pullup');
    if(form) {
        if(button) button.addEventListener('click', function(e) {
            if ( formSubmitted ) return false;
            else  e.preventDefault();
            console.log("Unit card open with button");
            // setTimeout(function () { // NOTE: This is a hack to fix the scroll to form issue
            //     document.getElementById('product-' + i).scrollIntoView(true);
            // }, 100);
            scrollToSmoothly(form.offsetTop - hoffset, 300);
            if(form) {
                document.querySelectorAll('.product-form').forEach(function(formelement) {
                    formelement.classList.add('hidden');
                    formelement.classList.add('closed');
                });
                document.querySelectorAll('.product-form-button').forEach(function(btnelement) {
                    btnelement.classList.remove('hidden');
                });
                document.querySelectorAll('.product-form-close').forEach(function(closeelement) {
                    closeelement.classList.add('hidden');
                });
                form.classList.remove('hidden');
                form.classList.remove('closed');
                if(close) close.classList.remove('hidden');
                button.classList.add('hidden');
            }
        });
        if(pullup) pullup.addEventListener('click', function(e) {
            // setTimeout(function () { // NOTE: This is a hack to fix the scroll to form issue
            //     document.getElementById('product-' + i).scrollIntoView(true);
            // }, 100);
            if(form) {
                document.querySelectorAll('.product-form').forEach(function(formelement) {
                    formelement.classList.add('hidden');
                });
                document.querySelectorAll('.product-form-close').forEach(function(closeelement) {
                    closeelement.classList.add('hidden');
                });
                form.classList.add('hidden');
                form.classList.add('closed');
                close.classList.add('hidden');
                if(button) button.classList.remove('hidden');
            }
        });
        if(close) close.addEventListener('click', function(e) {
            //e.preventDefault();
            //console.log("Unit card closed with button");
            setTimeout(function () {
                document.getElementById('product-' + i).scrollIntoView(true);
            }, 100);
            if(form) form.classList.add('hidden');
            if(form) form.classList.add('closed');
            if(button) button.classList.remove('hidden');
            close.classList.add('hidden');
        });
    }
});

/*
 * Unit Image Modal
 */
document.querySelectorAll('.product-image-open').forEach(function(element) {
    element.addEventListener('click', function(e) {
        //e.preventDefault();
        var modaltitle = document.getElementById('product-modal-title');
        var modalmetric = document.getElementById('product-modal-metric');
        var modalcontent = document.getElementById('product-modal-content');
        var modalcontents = document.getElementById('product-modal-contents');
        var datatitle = element.getAttribute('data-title');
        var datametric = element.getAttribute('data-metric');
        var datacontent = element.getAttribute('data-content');
        var datacontents = element.querySelector('.product-contents');
        if(modaltitle) modaltitle.textContent = datatitle;
        if(modalmetric) modalmetric.textContent = datametric;
        if(modalcontent) modalcontent.textContent = datacontent;
        if(modalcontents && datacontents) modalcontents.innerHTML = datacontents.innerHTML;
        var modalimg = document.getElementById('product-modal-image');
        var loading = document.getElementById('loading-modal-image');
        var datasrc = element.getAttribute('data-src');
        var downloadimg = new Image();
        downloadimg.onload = function() {
            modalimg.classList.remove('hidden');
            modalimg.onload = function() {
                loading.classList.add('hidden');
            }
            modalimg.src = this.src;
        };
        downloadimg.src = datasrc;
        loading.classList.remove('hidden');
        modalimg.classList.add('hidden');
    });
});

// Discount offer modal
var labelmodals = document.querySelectorAll('.label-modal-discount');
var discountmodal = document.querySelector('div#offer-modal-discount');

if(labelmodals.length > 0 && discountmodal) {

    var modalcontent = discountmodal.querySelector('.modal-content');

    labelmodals.forEach(function(element) {
        element.addEventListener('click', function(e) {
            var modaltext = element.querySelector('.content-modal-discount');
            modalcontent.innerHTML = modaltext.innerHTML;
        });
    });
}

/*
 * Form Validation
 */
var i;
var formSubmitted = false;
var pricesForms = document.querySelectorAll('.prices-form');
if(pricesForms.length > 0) pricesForms.forEach(function(element) {
    var priceForm = element.querySelector('form');
    priceForm.addEventListener('submit', function(event) {
        i = priceForm.getAttribute('data-index');
        var submitBtn = priceForm.querySelector(".product-form-submit");
        var loading = priceForm.querySelector(".product-form-loading");
        if (!validatePricesForm(element)) {
            event.preventDefault();
        } else {
            event.preventDefault();
            if(submitBtn) submitBtn.setAttribute("disabled", "disabled");
            if(loading) loading.classList.remove('hidden');
            var formData = new FormData(priceForm);
            fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: new URLSearchParams(formData)
            })
            .then(function(data) {
                var unit = document.getElementById('product-' + i);
                var close = unit.querySelector('.product-form-close');
                var button = unit.querySelector('.product-form-button');
                var pricing = unit.querySelector('.product-unit-pricing');
                if(close) close.click();
                if(pricing) pricing.classList.remove('hidden');
                if(loading) loading.classList.add('hidden');
                if(button) {
                    var link = button.getAttribute('data-link');
                    button.textContent = 'Reserve';
                    button.setAttribute('href', link);
                    button.classList.add('product-button');
                    button.classList.remove('hidden');
                }
                document.querySelectorAll('.product-unit-pricing').forEach(function(element) {
                    element.classList.remove('hidden');
                });
                document.querySelectorAll('.product-form-button').forEach(function(element) {
                    var link = element.getAttribute('data-link');
                    element.textContent = 'Reserve';
                    element.setAttribute('href', link);
                    element.classList.add('product-button');
                    element.classList.remove('hidden');
                });
                formSubmitted = true;

                // GTM price form event tracking
                if (typeof gtag_report_conversion === 'function') {
                    gtag_report_conversion();
                    //console.log("Prices form submitted");
                }

            })
            .catch(function(error) {
                if(loading) loading.classList.add('hidden');
                console.log('Request failed', error);
            });
        }
    });
});
function validatePricesForm(pricesForm) {
    var errorMsg = pricesForm.querySelector('#error');
    var firstName = pricesForm.querySelector('#firstName');
    var lastName = pricesForm.querySelector('#lastName');
    var emailAddr = pricesForm.querySelector('#emailAddress');
    var phoneNumber = pricesForm.querySelector('#phoneNumber');
    firstName.classList.remove('space-form-error');
    lastName.classList.remove('space-form-error');
    emailAddr.classList.remove('space-form-error');
    phoneNumber.classList.remove('space-form-error');
    if (firstName.value.trim() === '') {
        firstName.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your first name.';
        return false;
    }
    if (lastName.value.trim() === '') {
        lastName.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your last name.';
        return false;
    }
    // Email address validation
    var emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(emailAddr.value)) {
        emailAddr.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter a valid email address.';
        return false;
    }
    if (emailAddr.value.trim() === '') {
        emailAddr.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your email address.';
        return false;
    }
    if (phoneNumber.value.trim() === '') {
        phoneNumber.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your telephone number.';
        return false;
    }
    return true;
}

// Reservation form
var reservationForms = document.querySelectorAll('.reservation-form');
if(reservationForms.length > 0) reservationForms.forEach(function(element) {
    var reservationForm = element.querySelector('form');
    if(reservationForm) reservationForm.addEventListener('submit', function(event) {
        if (!validateReservationForm(reservationForm)) {
            event.preventDefault();
        } else {
            var submitBtn = reservationForm.querySelector(".reserve-form-submit");
            var resLoading = reservationForm.querySelector('.reserve-form-loading');
            if(submitBtn) submitBtn.setAttribute("disabled", "disabled");
            if(resLoading) resLoading.classList.remove('hidden');
            reservationForm.submit();
        }
    });
});
function validateReservationForm(reserveForm) {
    var errorMsg = reserveForm.querySelector('#error');
    var firstName = reserveForm.querySelector('#firstName');
    var lastName = reserveForm.querySelector('#lastName');
    var emailAddr = reserveForm.querySelector('#emailAddress');
    var phoneNumber = reserveForm.querySelector('#phoneNumber');
    var movingDate = reserveForm.querySelector('#movingDate');
    var acceptTerms = reserveForm.querySelector('#acceptTerms');
    firstName.classList.remove('space-form-error');
    lastName.classList.remove('space-form-error');
    emailAddr.classList.remove('space-form-error');
    phoneNumber.classList.remove('space-form-error');
    movingDate.classList.remove('space-form-error');
    if (firstName.value.trim() === '') {
        firstName.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your first name.';
        return false;
    }
    if (lastName.value.trim() === '') {
        lastName.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your last name.';
        return false;
    }
    // Email address validation
    var emailRegex = /^\S+@\S+\.\S+$/;
    if (!emailRegex.test(emailAddr.value)) {
        emailAddr.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter a valid email address.';
        return false;
    }
    if (emailAddr.value.trim() === '') {
        emailAddr.classList.add('space-form-error');space-form-error
        errorMsg.textContent = 'Please enter your email address.';
        return false;
    }
    if (phoneNumber.value.trim() === '') {
        phoneNumber.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your telephone number.';
        return false;
    }
    if (movingDate.value.trim() === '') {
        movingDate.classList.add('space-form-error');
        errorMsg.textContent = 'Please enter your estimated move-in date.';
        return false;
    }
    if (!acceptTerms.checked) {
        acceptTerms.classList.add('space-form-error'); // TODO add to label?
        errorMsg.textContent = 'Please accept the terms and conditions.';
        return false;
    }
    return true;
}

/*
 * Gallery Slides
 */
// document.querySelectorAll('.splide-slides').forEach(function(element) {
//     var g = element.getAttribute('data-gallery');
//     var gallery = document.getElementById(g);
//     element.querySelectorAll('li').forEach(function(slide) {
//         slide.addEventListener('click', function(e) {
//             var s = e.currentTarget.getAttribute('data-index');
//             console.log("Gallery " + g + " slide clicked: " + s);
//             var pagination = gallery.querySelector('.splide__pagination');
//             //console.log(pagination.innerHTML);
//             pagination.querySelector('button:nth-child(' + s + ')').click();
//         });
//     });
// });

// NOTE: Tree shaking for performance https://webpack.js.org/guides/tree-shaking/
// import Glide, { Controls, Breakpoints } from '@glidejs/glide/dist/glide.modular.esm'
// new Glide('.glide').mount({ Controls, Breakpoints })

/*
 * TEMPORARY HACK TO REMOVE THE PESKY "1" FROM SIDEBARS (COULD CAUSE ISSUES IN FUTURE)
 * TODO: REMOVE AND CORRECT TIMBER SIDEBARS
 */
function removeSidebar1Hack() {
    var sidebars = document.querySelectorAll('.footer-sidebar > div');
    for (var i = 0; i < sidebars.length; i++) {
        sidebars[i].removeChild(sidebars[i].lastChild);
    }
}
removeSidebar1Hack();

/*
 * Gravity Forms Apply Daisy UI
 */
var gfcheckboxes = document.querySelectorAll('.gform_wrapper input[type="checkbox"]');
if(gfcheckboxes) gfcheckboxes.forEach(function(element){
    element.classList.add('app-checkbox');
    element.classList.add('app-checkbox-primary');
    element.classList.add('border-space-light-grey');
});
var gfbuttons = document.querySelectorAll('.gform_wrapper input[type="submit"]');
if(gfbuttons) gfbuttons.forEach(function(element){
    element.classList.add('!app-btn');
    element.classList.add('!app-btn-secondary');
    element.classList.add('!text-white');
});